import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const CartIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        d="M12 4.56205L7.76825 9.64018C7.41468 10.0645 6.78412 10.1218 6.35984 9.76822C5.93556 9.41466 5.87824 8.78409 6.2318 8.35982L11.2318 2.35982C11.6316 1.88006 12.3685 1.88006 12.7682 2.35982L17.7682 8.35982C18.1218 8.78409 18.0645 9.41466 17.6402 9.76822C17.2159 10.1218 16.5854 10.0645 16.2318 9.64018L12 4.56205Z"
        {...svgAttrs}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.28075 9H20.7192C21.2715 9 21.7192 9.44772 21.7192 10C21.7192 10.0818 21.7092 10.1632 21.6893 10.2425L19.5681 18.7276C19.2342 20.0631 18.0343 21 16.6576 21H7.34231C5.9657 21 4.76575 20.0631 4.43188 18.7276L2.31061 10.2425C2.17666 9.70674 2.50242 9.16381 3.03822 9.02986C3.11754 9.01003 3.19899 9 3.28075 9ZM12 12C11.4477 12 11 12.4477 11 13V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V13C13 12.4477 12.5523 12 12 12ZM6.9647 12.1363C6.43124 12.2792 6.11465 12.8276 6.25759 13.361L7.29287 17.2247C7.43581 17.7582 7.98415 18.0748 8.51762 17.9319C9.05108 17.7889 9.36766 17.2406 9.22472 16.7071L8.18945 12.8434C8.0465 12.3099 7.49817 11.9934 6.9647 12.1363ZM17.0353 12.1363C16.5018 11.9934 15.9535 12.3099 15.8105 12.8434L14.7752 16.7071C14.6323 17.2406 14.9489 17.7889 15.4823 17.9319C16.0158 18.0748 16.5641 17.7582 16.7071 17.2247L17.7424 13.361C17.8853 12.8276 17.5687 12.2792 17.0353 12.1363Z"
        {...svgAttrs}
      />
    </svg>
  );
};

export default CartIcon;
